import { Dispatch, useEffect, useState } from "react";
import { FileVersionInterface } from "../../../middleware/interfaces/file/file-version-interface";
import {
  BytesToReadableSize,
  FormatDateFE,
} from "../../../helper/general/methods";

type FileVersionListProps = {
  fileVersions: { [key: string]: FileVersionInterface };
  fileActiveVersion: number;
  select: boolean;
  setNewFileVersion: Dispatch<React.SetStateAction<string>>;
};

const FileVersionList: React.FC<FileVersionListProps> = ({
  fileVersions,
  fileActiveVersion,
  select,
  setNewFileVersion,
}) => {
  const [selectedFileVersion, setSelectedFileVersion] = useState("");

  useEffect(() => {
    if (select) {
      setNewFileVersion(selectedFileVersion);
    }
  }, [select]);

  useEffect(() => {
    setSelectedFileVersion(fileActiveVersion.toString());
  }, []);

  return (
    <div className="dialogValueListWrapper">
      {Object.entries(fileVersions).map(
        ([key, { fileSize, fileUploadDate, fileUploadedBy }]) => (
          <label
            key={key}
            className={
              key === selectedFileVersion
                ? "dialogCheckRow dialogCheckRowSelected fileVersionWrapper"
                : "dialogCheckRow fileVersionWrapper"
            }
          >
            <input
              type="radio"
              name="fileVersion"
              value={key}
              checked={key === selectedFileVersion}
              onChange={() => setSelectedFileVersion(key)}
            />
            <span className="dialogCheckRowLabel">Version {key}</span>
            <span className="dialogCheckRowDescription">
              {FormatDateFE(fileUploadDate, true)} ·{" "}
              {BytesToReadableSize(fileSize)} · {fileUploadedBy}
            </span>
          </label>
        )
      )}
    </div>
  );
};

export default FileVersionList;
